import React from 'react';
import { Link } from 'react-router-dom';
const Hero = () => {
  return <div className="relative bg-mwc-burgundy text-white" data-id="element-41">
      <div className="absolute inset-0 opacity-30 bg-cover bg-center" style={{
      backgroundImage: "url('https://uploadthingy.s3.us-west-1.amazonaws.com/cyEqTLw7JXibdBhz3wF3d4/01._Footer.png')",
      backgroundBlendMode: 'overlay'
    }} data-id="element-42"></div>
      <div className="container mx-auto px-4 py-16 md:py-24 relative z-10" data-id="element-43">
        <div className="flex flex-col md:flex-row items-center" data-id="element-44">
          <div className="md:w-full mb-8 md:mb-0" data-id="element-45">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4" data-id="element-46">
              Professional Appliance Repair Services
            </h1>
            <p className="text-lg md:text-xl mb-8" data-id="element-47">
              Expert diagnostics, repairs, and maintenance for all major
              household appliances. Our qualified engineers provide reliable
              service visits with transparent pricing and quality workmanship
              across the UK.
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-48">
              <Link to="/service-coverage" className="bg-white text-mwc-burgundy hover:bg-gray-100 font-semibold px-6 py-3 rounded-md transition-colors duration-300 text-center" data-id="element-49">
                View Service Details
              </Link>
              <Link to="/contact-us" className="bg-mwc-green hover:bg-mwc-green/80 font-semibold px-6 py-3 rounded-md transition-colors duration-300 text-center" data-id="element-50">
                Book a Repair
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Hero;